import { render } from "./ArticleCta.vue?vue&type=template&id=44ce4a41&scoped=true"
import script from "./ArticleCta.vue?vue&type=script&lang=js"
export * from "./ArticleCta.vue?vue&type=script&lang=js"

import "./ArticleCta.vue?vue&type=style&index=0&id=44ce4a41&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ce4a41"]])

export default __exports__